import * as accountActions from 'redux/actions/account.actions'
import * as actions from 'redux/actions/user.actions'

const initialState = {
  isLoggedIn: !!localStorage.getItem('jwt'),
  token: localStorage.getItem('jwt'),
  errors: [],
  loading: false,
  dataLoadedAt: null,
  dataHasBeenLoaded: false,
  emailNotifications: [],
  data: null,
  id: null
}

const userReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.login.type:
    case actions.register.type:
    case actions.updateProfile.type:
      return {
        ...state,
        loading: true
      }
    case actions.loginSuccess.type:
      return {
        ...state,
        isLoggedIn: true,
        token: payload.token,
        dataLoadedAt: new Date(),
        dataHasBeenLoaded: true,
        data: payload.data,
        loading: false
      }
    case actions.autoLoginSuccess.type:
      return {
        ...state,
        isLoggedIn: true,
        token: payload.token
      }
    case actions.getCurrentUserSuccess.type:
      return {
        ...state,
        dataLoadedAt: new Date(),
        dataHasBeenLoaded: true,
        data: payload.user,
        id: payload.id,
        loading: false
      }
    case actions.loginFailure.type:
      return {
        ...state,
        errors: payload.errors,
        loading: false
      }
    case accountActions.getAccountDataFailure.type:
    case actions.getCurrentUserFailure.type:
    case actions.logoutSuccess.type:
      return {
        errors: [],
        isLoggedIn: false,
        token: null,
        dataLoadedAt: null,
        dataHasBeenLoaded: false,
        data: null
      }
    case actions.updateProfileSuccess.type:
    case actions.updatePasswordSuccess.type:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          ...payload.data
        }
      }
    case actions.updateProfileFailure.type:
    case actions.updatePasswordFailure.type:
      return {
        ...state,
        loading: false,
        errors: payload.errors
      }
    case actions.getEmailNotificationsSuccess.type:
      return {
        ...state,
        emailNotifications: payload.emailNotifications
      }
    default:
      return state
  }
}

export default userReducer
